"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PageHelper {
    static setMakeDescription(filterFormData, isFilteredOneMakeOnly) {
        var _a;
        const makeDescriptionContainer = document.getElementById('make-description');
        const headline = 'O značce ';
        function hideDescription(makeDescriptionElement, makeHeadlineElement, makeTextElement) {
            makeDescriptionElement.classList.add('hidden');
            makeHeadlineElement.innerHTML = '';
            makeTextElement.innerHTML = '';
        }
        if (makeDescriptionContainer) {
            const makeHeadlineElement = makeDescriptionContainer.querySelector('.section-title');
            const makeTextElement = makeDescriptionContainer.querySelector('.section-description');
            if (makeTextElement && makeHeadlineElement) {
                if (isFilteredOneMakeOnly) {
                    const selectedMake = (_a = filterFormData.getSelectedMakes()[0]) !== null && _a !== void 0 ? _a : null;
                    if (selectedMake !== null && selectedMake.description !== null) {
                        makeDescriptionContainer.classList.remove('hidden');
                        makeHeadlineElement.innerHTML = headline + selectedMake.label;
                        makeTextElement.innerHTML = selectedMake.description;
                    }
                    else {
                        hideDescription(makeDescriptionContainer, makeHeadlineElement, makeTextElement);
                    }
                }
                else {
                    hideDescription(makeDescriptionContainer, makeHeadlineElement, makeTextElement);
                }
            }
        }
    }
    static shouldOpenInNewTab(event) {
        return (event.button === 0 && event.ctrlKey === true) || (event.button === 0 && event.metaKey === true) || (event.button === 1);
    }
}
exports.default = PageHelper;
